var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Set",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFB300;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#90CAF9;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#FF7043;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#9CCC65;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#37474F;}\n\t.st7{fill:#37474F;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#37474F;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manager"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 32,
    cy: 7,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 32,
    y1: 14,
    x2: 32,
    y2: 20
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 4.4227 38.7366)",
    className: "st4",
    cx: 49,
    cy: 14,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 56,
    cy: 31,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 49,
    y1: 31,
    x2: 43,
    y2: 31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 8,
    cy: 31,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 15,
    y1: 31,
    x2: 21,
    y2: 31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.5184 14.7366)",
    className: "st4",
    cx: 15,
    cy: 14,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 20,
    y1: 19,
    x2: 24.2,
    y2: 23.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 44,
    y1: 19,
    x2: 39.8,
    y2: 23.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 58,
    x2: 8,
    y2: 58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6,
    y1: 58,
    x2: 5,
    y2: 58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 51,
    y1: 58,
    x2: 56,
    y2: 58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 58,
    y1: 58,
    x2: 59,
    y2: 58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 31,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,26.4l0.6-0.5C36.7,24.1,34.5,23,32,23c-4.4,0-8,3.6-8,8h0.8C29.4,31,34,29.4,37.5,26.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,39c-1.1,0-2.1-0.2-3-0.6l0,1.6l3,4.5l3-4.5l0-1.6C34.1,38.8,33.1,39,32,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,62V47.3c0-2,1.2-3.8,3-4.6l6-2.7l3,4.5l3-4.5l3.8,1.7c1.1,0.5,2.1,1.2,2.9,2l3.7,3.7l5.3-5.3l3.5,3.5 l-7.1,7.1c-1,1-2.6,1-3.5,0L39,48.1L39,62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25,
    y1: 50,
    x2: 25,
    y2: 62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "34.5,56.5 32,59 29.5,56.5 31,44.5 33,44.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "29,40 28.5,44.5 35.5,44.5 35,40 32,44.5  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.1,40.7L52.1,40.7c1-1,2.6-1,3.5,0l0,0c1,1,1,2.6,0,3.5l0,0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/관리팀.519a5652327de4053c1701d2dcf77926.svg";
export { ForwardRef as ReactComponent };